import {
  take,
  put,
  call,
  all,
  takeLatest,
  takeEvery,
} from 'redux-saga/effects';
import { travelAndClaimAction as actions, notificationActions } from '../actions';
import { travelAndClaimService } from '../services';

/* Add Travel Sagas */
function* handleCreateTravelApplicationRequest() {
  const action = yield take(actions.createTravelApplicationRequest.getType());
  const dataParams = action.payload;
  let res;

  try {
    res = yield call(travelAndClaimService.createTravelApplication, dataParams);
    if (res.isError) {
      yield put(actions.createTravelApplicationError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.createTravelApplicationSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.createTravelApplicationError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Get All Travel Sagas*/
function* handleGetTravelRequestRequest() {
  const action = yield take(actions.getTravelRequestRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(travelAndClaimService.getTravelRequest, dataParams);

    if (res.isError) {
      yield put(actions.getTravelRequestError(res));

    } else {
      yield put(actions.getTravelRequestSuccess(res));
    }

  } catch (error) {
    yield put(actions.getTravelRequestError());
  }
}

/* Get Travel List Sagas*/
function* handleGetTravelApprovalRequest() {
  const action = yield take(actions.getTravelApprovalRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(travelAndClaimService.getTravelApproval, dataParams);

    if (res.isError) {
      yield put(actions.getTravelApprovalError(res));

    } else {
      yield put(actions.getTravelApprovalSuccess(res));
    }

  } catch (error) {
    yield put(actions.getTravelApprovalError());
  }
}

/* Update Travel Sagas */
function* handleUpdateTravelApplicationRequest() {
  const action = yield take(actions.updateTravelApplicationRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(travelAndClaimService.updateTravelApplication, dataParams);
    if (res.isError) {
      yield put(actions.updateTravelApplicationError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.updateTravelApplicationSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.updateTravelApplicationError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}
/* Delete Travel Sagas*/
function* handleDeleteTravelRequest() {
  const action = yield take(actions.deleteTravelRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(travelAndClaimService.deleteTravel, dataParams);
    if (res.isError) {
      yield put(actions.deleteTravelError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.deleteTravelSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.deleteTravelError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Add Travel Type Sagas*/
function* handleAddTravelTypeRequest() {
  const action = yield take(actions.addTravelTypeRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(travelAndClaimService.addTravelType, dataParams);
    if (res.isError) {
      yield put(actions.addTravelTypeError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.addTravelTypeSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.addTravelTypeError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Get Travel Type Sagas*/
function* handleGetTravelTypeRequest() {
  const action = yield take(actions.getTravelTypeRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(travelAndClaimService.getTravelType, dataParams);
    if (res.isError) {
      yield put(actions.getTravelTypeError(res));
    } else {
      yield put(actions.getTravelTypeSuccess(res));
    }
  } catch (error) {
    yield put(actions.getTravelTypeError());
  }
}

/* update Travel Type Sagas*/
function* handleUpdateTravelTypeRequest() {
  const action = yield take(actions.updateTravelTypeRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(travelAndClaimService.updateTravelType, dataParams);
    if (res.isError) {
      yield put(actions.updateTravelTypeError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.updateTravelTypeSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.updateTravelTypeError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Delete Travel Type Sagas*/
function* handleDeleteTravelTypeRequest() {
  const action = yield take(actions.deleteTravelTypeRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(travelAndClaimService.deleteTravelType, dataParams);
    if (res.isError) {
      yield put(actions.deleteTravelTypeError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.deleteTravelTypeSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.deleteTravelTypeError())
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}
/* Get All Travel Type Sagas*/
function* handleGetAllTravelTypeRequest() {
  const action = yield take(actions.getAllTravelTypeRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(travelAndClaimService.getAllTravelType, dataParams);
    if (res.isError) {
      yield put(actions.getAllTravelTypeError(res));
    } else {
      yield put(actions.getAllTravelTypeSuccess(res));
    }
  } catch (error) {
    yield put(actions.getAllTravelTypeError());
  }
}
/* Travel Request Approve Reject Sagas*/
function* handleTravelRequestApproveRejectRequest() {
  const action = yield take(actions.travelRequestApproveRejectRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(travelAndClaimService.travelRequestApproveReject, dataParams);
    if (res.isError) {
      yield put(actions.travelRequestApproveRejectError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.travelRequestApproveRejectSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.travelRequestApproveRejectError()); yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Create Travel And Claim Rule Sagas*/
function* handleCreateTravelAndClaimRuleRequest() {
  const action = yield take(actions.createTravelAndClaimRuleRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(travelAndClaimService.createTravelAndClaimRule, dataParams);
    if (res.isError) {
      yield put(actions.createTravelAndClaimRuleError(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.createTravelAndClaimRuleSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.createTravelAndClaimRuleError());
    yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'error' }));
  }
}

/* Get Travel And Claim Rule Sagas*/
function* handleGetTravelAndClaimRuleRequest() {
  const action = yield take(actions.getTravelAndClaimRuleRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(travelAndClaimService.getTravelAndClaimRule, dataParams);
    if (res.isError) {
      yield put(actions.getTravelAndClaimRuleError(res));
    } else {
      yield put(actions.getTravelAndClaimRuleSuccess(res));
    }
  } catch (error) {
    yield put(actions.getTravelAndClaimRuleError());
  }
}

/* Update Travel And Claim Rule Sagas*/
function* handleUpdateTravelAndClaimRuleRequest() {
  const action = yield take(actions.updateTravelAndClaimRuleRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(travelAndClaimService.updateTravelAndClaimRule, dataParams);
    if (res.isError) {
      yield put(actions.updateTravelAndClaimRuleError(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.updateTravelAndClaimRuleSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.updateTravelAndClaimRuleError());
    yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'error' }));
  }
}

/* Delete Travel And Claim Rule Sagas*/
function* handleDeleteTravelAndClaimRuleRequest() {
  const action = yield take(actions.deleteTravelAndClaimRuleRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(travelAndClaimService.deleteTravelAndClaimRule, dataParams);
    if (res.isError) {
      yield put(actions.deleteTravelAndClaimRuleError(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.deleteTravelAndClaimRuleSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.deleteTravelAndClaimRuleError());
    yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'error' }));
  }
}

/* Get All Travel And Claim Rule Sagas*/
function* handleGetAllTravelAndClaimRuleRequest() {
  const action = yield take(actions.getAllTravelAndClaimRuleRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(travelAndClaimService.getAllTravelAndClaimRule, dataParams);
    if (res.isError) {
      yield put(actions.getAllTravelAndClaimRuleError(res));
    } else {
      yield put(actions.getAllTravelAndClaimRuleSuccess(res));
    }
  } catch (error) {
    yield put(actions.getAllTravelAndClaimRuleError());
  }
}
/* Assign Rule Sagas*/
function* handleAssignRuleRequest() {
  const action = yield take(actions.assignRuleRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(travelAndClaimService.assignRule, dataParams);
    if (res.isError) {
      yield put(actions.assignRuleError(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.assignRuleSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.assignRuleError());
    yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'error' }));
  }
}

/* Assign Rule Sagas*/
function* handleGetAssignRuleRequest() {
  const action = yield take(actions.getAssignRuleRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(travelAndClaimService.getAssignRule, dataParams);
    if (res.isError) {
      yield put(actions.getAssignRuleError(res));
    } else {
      yield put(actions.getAssignRuleSuccess(res));
    }
  } catch (error) {
    yield put(actions.getAssignRuleError());
  }
}

/* Assign Rule Sagas*/
function* handleGetTravelTypeByIdRequest() {
  const action = yield take(actions.getTravelTypeByIdRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(travelAndClaimService.getTravelTypeById, dataParams);
    if (res.isError) {
      yield put(actions.getTravelTypeByIdError(res));
    } else {
      yield put(actions.getTravelTypeByIdSuccess(res));
    }
  } catch (error) {
    yield put(actions.getTravelTypeByIdError());
  }
}

/* Create claim Sagas*/
function* handleCreateClaimRequest() {
  const action = yield take(actions.createClaimRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(travelAndClaimService.createClaim, dataParams);
    if (res.isError) {
      yield put(actions.createClaimError(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.createClaimSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.createClaimError());
  }
}

/* Update claim Sagas*/
function* handleUpdateClaimRequest() {
  const action = yield take(actions.updateClaimRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(travelAndClaimService.updateClaim, dataParams);
    if (res.isError) {
      yield put(actions.updateClaimError(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.updateClaimSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.updateClaimError());
    yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'error' }));
  }
}

/* Delete claim Sagas*/
function* handleDeleteClaimRequest() {
  const action = yield take(actions.deleteClaimRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(travelAndClaimService.deleteClaim, dataParams);
    if (res.isError) {
      yield put(actions.deleteClaimError(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.deleteClaimSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.deleteClaimError());
    yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'error' }));
  }
}

/* Get claim Sagas*/
function* handleGetClaimRequest() {
  const action = yield take(actions.getClaimRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(travelAndClaimService.getClaim, dataParams);
    if (res.isError) {
      yield put(actions.getClaimError(res));
    } else {
      yield put(actions.getClaimSuccess(res));
    }
  } catch (error) {
    yield put(actions.getClaimError());
  }
}

/* Get claim Sagas*/
function* handleGetClaimApprovalRequest() {
  const action = yield take(actions.getClaimApprovalRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(travelAndClaimService.getClaimApproval, dataParams);
    if (res.isError) {
      yield put(actions.getClaimApprovalError(res));
    } else {
      yield put(actions.getClaimApprovalSuccess(res));
    }
  } catch (error) {
    yield put(actions.getClaimApprovalError());
  }
}


/* Approve Reject Claim Sagas*/
function* handleApproveRejectClaimRequest() {
  const action = yield take(actions.approveRejectClaimRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(travelAndClaimService.approveRejectClaim, dataParams);
    if (res.isError) {
      yield put(actions.approveRejectClaimError(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.approveRejectClaimSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.approveRejectClaimError());
    yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'error' }));
  }
}


/* Get All Travel Approval Data Sagas*/
function* handleGetAllTravelApprovalDataRequest() {
  const action = yield take(actions.getAllTravelApprovalDataRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(travelAndClaimService.getAllTravelApprovalData, dataParams);
    if (res.isError) {
      yield put(actions.getAllTravelApprovalDataError(res));
    } else {
      yield put(actions.getAllTravelApprovalDataSuccess(res));
    }
  } catch (error) {
    yield put(actions.getAllTravelApprovalDataError());
  }
}


/* -----------Watchers------------- */
function* handleCreateTravelApplicationWatcher() {
  yield takeEvery(
    actions.createTravelApplicationRequest,
    handleCreateTravelApplicationRequest,
  );
}

function* handleGetTravelRequestWatcher() {
  yield takeEvery(
    actions.getTravelRequestRequest,
    handleGetTravelRequestRequest,
  );
}

function* handleGetTravelApprovalWatcher() {
  yield takeEvery(
    actions.getTravelApprovalRequest,
    handleGetTravelApprovalRequest,
  );
}

function* handleUpdateTravelApplicationWatcher() {
  yield takeEvery(
    actions.updateTravelApplicationRequest,
    handleUpdateTravelApplicationRequest,
  );
}

function* handleDeleteTravelWatcher() {
  yield takeEvery(
    actions.deleteTravelRequest,
    handleDeleteTravelRequest,
  );
}

function* handleAddTravelTypeWatcher() {
  yield takeEvery(
    actions.addTravelTypeRequest,
    handleAddTravelTypeRequest,
  );
}

function* handleGetTravelTypeWatcher() {
  yield takeEvery(
    actions.getTravelTypeRequest,
    handleGetTravelTypeRequest,
  );
}


function* handleUpdateTravelTypeWatcher() {
  yield takeEvery(
    actions.updateTravelTypeRequest,
    handleUpdateTravelTypeRequest,
  );
}


function* handleDeleteTravelTypeWatcher() {
  yield takeEvery(
    actions.deleteTravelTypeRequest,
    handleDeleteTravelTypeRequest,
  );
}

function* handleGetAllTravelTypeWatcher() {
  yield takeEvery(
    actions.getAllTravelTypeRequest,
    handleGetAllTravelTypeRequest,
  );
}


function* handleTravelRequestApproveRejectWatcher() {
  yield takeEvery(
    actions.travelRequestApproveRejectRequest,
    handleTravelRequestApproveRejectRequest,
  );
}

function* handleCreateTravelAndClaimRuleWatcher() {
  yield takeEvery(
    actions.createTravelAndClaimRuleRequest,
    handleCreateTravelAndClaimRuleRequest,
  );
}


function* handleGetTravelAndClaimRuleWatcher() {
  yield takeEvery(
    actions.getTravelAndClaimRuleRequest,
    handleGetTravelAndClaimRuleRequest,
  );
}

function* handleUpdateTravelAndClaimRuleWatcher() {
  yield takeEvery(
    actions.updateTravelAndClaimRuleRequest,
    handleUpdateTravelAndClaimRuleRequest,
  );
}

function* handleDeleteTravelAndClaimRuleWatcher() {
  yield takeEvery(
    actions.deleteTravelAndClaimRuleRequest,
    handleDeleteTravelAndClaimRuleRequest,
  );
}

function* handleGetAllTravelAndClaimRuleWatcher() {
  yield takeEvery(
    actions.getAllTravelAndClaimRuleRequest,
    handleGetAllTravelAndClaimRuleRequest,
  );
}
function* handleAssignRuleWatcher() {
  yield takeEvery(
    actions.assignRuleRequest,
    handleAssignRuleRequest,
  );
}

function* handleGetAssignRuleWatcher() {
  yield takeEvery(
    actions.getAssignRuleRequest,
    handleGetAssignRuleRequest,
  );
}
function* handleGetTravelTypeByIdWatcher() {
  yield takeEvery(
    actions.getTravelTypeByIdRequest,
    handleGetTravelTypeByIdRequest,
  );
}

function* handleCreateClaimWatcher() {
  yield takeEvery(
    actions.createClaimRequest,
    handleCreateClaimRequest,
  );
}

function* handleUpdateClaimWatcher() {
  yield takeEvery(
    actions.updateClaimRequest,
    handleUpdateClaimRequest,
  );
}

function* handleDeleteClaimWatcher() {
  yield takeEvery(
    actions.deleteClaimRequest,
    handleDeleteClaimRequest,
  );
}

function* handleGetClaimWatcher() {
  yield takeEvery(
    actions.getClaimRequest,
    handleGetClaimRequest,
  );
}

function* handleGetClaimApprovalWatcher() {
  yield takeEvery(
    actions.getClaimApprovalRequest,
    handleGetClaimApprovalRequest,
  );
}

function* handleApproveRejectClaimWatcher() {
  yield takeEvery(
    actions.approveRejectClaimRequest,
    handleApproveRejectClaimRequest,
  );
}
function* handleGetAllTravelApprovalDataWatcher() {
  yield takeEvery(
    actions.getAllTravelApprovalDataRequest,
    handleGetAllTravelApprovalDataRequest,
  );
}



function* rootTravelAndClaimSaga() {
  yield all([
    handleCreateTravelApplicationRequest(),
    handleCreateTravelApplicationWatcher(),

    handleGetTravelRequestRequest(),
    handleGetTravelRequestWatcher(),

    handleGetTravelApprovalRequest(),
    handleGetTravelApprovalWatcher(),

    handleUpdateTravelApplicationRequest(),
    handleUpdateTravelApplicationWatcher(),

    handleDeleteTravelRequest(),
    handleDeleteTravelWatcher(),

    handleAddTravelTypeRequest(),
    handleAddTravelTypeWatcher(),

    handleGetTravelTypeRequest(),
    handleGetTravelTypeWatcher(),

    handleUpdateTravelTypeRequest(),
    handleUpdateTravelTypeWatcher(),

    handleDeleteTravelTypeRequest(),
    handleDeleteTravelTypeWatcher(),

    handleGetAllTravelTypeRequest(),
    handleGetAllTravelTypeWatcher(),

    handleTravelRequestApproveRejectRequest(),
    handleTravelRequestApproveRejectWatcher(),

    handleCreateTravelAndClaimRuleRequest(),
    handleCreateTravelAndClaimRuleWatcher(),

    handleGetTravelAndClaimRuleRequest(),
    handleGetTravelAndClaimRuleWatcher(),

    handleUpdateTravelAndClaimRuleRequest(),
    handleUpdateTravelAndClaimRuleWatcher(),

    handleDeleteTravelAndClaimRuleRequest(),
    handleDeleteTravelAndClaimRuleWatcher(),

    handleGetAllTravelAndClaimRuleRequest(),
    handleGetAllTravelAndClaimRuleWatcher(),

    handleAssignRuleRequest(),
    handleAssignRuleWatcher(),

    handleGetAssignRuleRequest(),
    handleGetAssignRuleWatcher(),

    handleGetTravelTypeByIdRequest(),
    handleGetTravelTypeByIdWatcher(),

    handleCreateClaimRequest(),
    handleCreateClaimWatcher(),

    handleUpdateClaimRequest(),
    handleUpdateClaimWatcher(),

    handleDeleteClaimRequest(),
    handleDeleteClaimWatcher(),
    
    handleGetClaimRequest(),
    handleGetClaimWatcher(),

    handleGetClaimApprovalRequest(),
    handleGetClaimApprovalWatcher(),

    handleApproveRejectClaimRequest(),
    handleApproveRejectClaimWatcher(),

    handleGetAllTravelApprovalDataRequest(),
    handleGetAllTravelApprovalDataWatcher(),

  ]);
}

export default rootTravelAndClaimSaga;
